export const LOCALE_MAP = {
  pt: 'pt-BR',
  en: 'en-US',
  es: 'es-419',
};

export const formatDate = (isoString, locale, options = {}) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...options,
  }).format(d);
};

export const formatDateTime = (isoString, locale, timezone) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone || 'UTC',
  }).format(d);
};

export const formatCurrency = (amount, locale, currencyCode) => {
  if (amount == null) return '';
  if (!currencyCode) return '';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount);
};

export const formatNumber = (value, locale, options = {}) => {
  if (value == null) return '';
  return new Intl.NumberFormat(locale, options).format(value);
};

export const formatComplianceDate = (isoString, locale) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
};
